import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import React from 'react';

import { VerificationPipelineStatusGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { Icon } from '~/packages/common-frontend/components/icons';
import { ColorScheme } from '~/packages/common-frontend/theme';

const statusConfigs: Record<
  VerificationPipelineStatusGQLType,
  { colorScheme: ColorScheme; label: string; icon?: string }
> = {
  // TODO(jon): split this up into approved and rejected
  complete: {
    colorScheme: 'green',
    label: 'Reviewed',
  },
  awaitingApproval: {
    colorScheme: 'blue',
    label: 'Ready to verify',
  },
  error: {
    colorScheme: 'red',
    label: 'Error',
  },
  notStarted: {
    colorScheme: 'gray',
    label: 'Not started',
  },
  inProgress: {
    colorScheme: 'gray',
    label: 'In progress',
  },
  superseded: {
    colorScheme: 'gray',
    label: 'Expired',
  },
  remediationRequested: {
    colorScheme: 'red',
    label: 'Remediation Requested',
    icon: 'circle-exclamation',
  },
};

export const StatusBadge = ({
  value,
}: {
  value: VerificationPipelineStatusGQLType;
}) => {
  const { colorScheme, label, icon } = statusConfigs[value];

  return (
    <Tag variant="solid-muted" colorScheme={colorScheme} size="md">
      {icon && (
        <TagLeftIcon>
          <Icon icon={icon} />
        </TagLeftIcon>
      )}
      <TagLabel>{label}</TagLabel>
    </Tag>
  );
};
